import axios from "axios";
import { requestUrl } from "./constants";

// 获取时区
const timeZoneOffset = new Date().getTimezoneOffset();
const offsetHour = Math.abs(timeZoneOffset / 60); //单位小时
const offsetMinute = Math.abs(timeZoneOffset % 60);
let timezone = timeZoneOffset <= 0 ? "+" : "-";
timezone += (offsetHour < 10 ? "0" + offsetHour : offsetHour) + ":" + (offsetMinute < 10 ? "0" + offsetMinute : offsetMinute);

const service = axios.create({
	baseURL: requestUrl,
	// timeout: 6000, // 请求超时时间毫秒
	withCredentials: true, // 异步请求携带cookie
	headers: {
		// 设置后端需要的传参类型
		"Content-Type": "application/json",
		"co-id": "xcharge",
	},
});

service.interceptors.request.use(
	config => {
		config.params = { ...config.params, lang: "en", timezone: timezone, r: Math.round(Math.random() * 100000) };
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

service.interceptors.response.use(
	response => {
		const res = response.data || {};
		if (res.error?.code == "NOT_LOGIN") {
			window.location.href = window.location.origin + "/login";
			return;
		}
		return res;
	},
	error => {
		console.log(error);
		return Promise.reject(error);
	}
);
export default service;
